import React, { useState } from "react";
import ClientNavbar from "../layout/ClientNavbar";
import { NavLink } from "react-router-dom";

export default function RedeemMf() {
  /* ------------------ STATIC DATA ------------------ */
  const holdings = [
    {
      id: 1,
      fund: "Axis Bluechip Fund",
      folio: "AXIS12345",
      units: 120.456,
      nav: 52.34,
      value: 6305,
      exitLoad: "1% if redeemed within 12 months",
    },
    {
      id: 2,
      fund: "HDFC Midcap Opportunities",
      folio: "HDFC67890",
      units: 80.25,
      nav: 68.9,
      value: 5530,
      exitLoad: "Nil",
    },
  ];

  const bankDetails = {
    bank: "HDFC Bank",
    account: "XXXXXX4321",
    ifsc: "HDFC0000123",
  };

  /* ------------------ STATES ------------------ */
  const [selectedHolding, setSelectedHolding] = useState(null);
  const [redeemType, setRedeemType] = useState("amount");
  const [redeemValue, setRedeemValue] = useState("");
  const [showOtp, setShowOtp] = useState(false);

  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: "#f1f5f9" }}>
          {/* Header */}
          <div className="card shadow-sm p-4 mb-4">
            <h3 className="text-primary mb-2">Redeem Mutual Fund</h3>

            {/* Breadcrumb */}
            <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none" }}>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <NavLink to="/overview">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item">
                  <NavLink to="/clientmutualfunds">Mutual Funds</NavLink> /
                </li>
                <li className="breadcrumb-item active">Redeem</li>
              </ol>
            </nav>
          </div>

          {/* Holding Selection */}
          <div className="card shadow-sm p-4 mb-4">
            <h5 className="mb-3">Select Holding</h5>

            <div className="row g-3">
              {holdings.map((item) => (
                <div className="col-12 col-md-6" key={item.id}>
                  <div
                    className={`border rounded p-3 h-100 ${
                      selectedHolding?.id === item.id
                        ? "border-primary bg-light"
                        : ""
                    }`}
                    role="button"
                    onClick={() => setSelectedHolding(item)}
                  >
                    <h6 className="mb-1">{item.fund}</h6>
                    <small className="text-muted">Folio: {item.folio}</small>

                    <div className="d-flex justify-content-between mt-2">
                      <span>Units: {item.units}</span>
                      <span>Value: ₹{item.value}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Redeem Form */}
          {selectedHolding && (
            <div className="card shadow-sm p-4 mb-4">
              <h5 className="mb-3">Redemption Details</h5>

              {/* Redeem Type */}
              <div className="mb-3">
                <label className="form-label">Redeem By</label>
                <div className="d-flex gap-3">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      checked={redeemType === "amount"}
                      onChange={() => setRedeemType("amount")}
                    />
                    <label className="form-check-label">Amount</label>
                  </div>

                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      checked={redeemType === "units"}
                      onChange={() => setRedeemType("units")}
                    />
                    <label className="form-check-label">Units</label>
                  </div>
                </div>
              </div>

              {/* Input */}
              <div className="mb-3">
                <label className="form-label">
                  Enter {redeemType === "amount" ? "Amount (₹)" : "Units"}
                </label>
                <input
                  type="number"
                  className="form-control"
                  placeholder={
                    redeemType === "amount"
                      ? "Enter redeem amount"
                      : "Enter units"
                  }
                  value={redeemValue}
                  onChange={(e) => setRedeemValue(e.target.value)}
                />
                <small className="text-muted">
                  Available Units: {selectedHolding.units}
                </small>
              </div>

              {/* Exit Load */}
              <div className="alert alert-warning">
                <strong>Exit Load:</strong> {selectedHolding.exitLoad}
              </div>

              {/* Bank */}
              <div className="border rounded p-3 mb-3">
                <h6>Credit to Bank</h6>
                <p className="mb-1">{bankDetails.bank}</p>
                <small>
                  A/C: {bankDetails.account} | IFSC: {bankDetails.ifsc}
                </small>
              </div>

              {/* Timeline */}
              <div className="mb-3">
                <h6>Payout Timeline</h6>
                <ul className="small text-muted mb-0">
                  <li>Redemption request: Today (T)</li>
                  <li>Units processed: T+1 business day</li>
                  <li>Payout credited: T+2 / T+3 business days</li>
                </ul>
              </div>

              {/* Submit */}
              <div className="text-end">
                <button
                  className="btn btn-primary"
                  onClick={() => setShowOtp(true)}
                >
                  Submit Redemption
                </button>
              </div>
            </div>
          )}

          {/* OTP Modal */}
          {showOtp && (
            <div className="modal fade show d-block" style={{ background: "#0008" }}>
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">OTP Verification</h5>
                    <button
                      className="btn-close"
                      onClick={() => setShowOtp(false)}
                    />
                  </div>

                  <div className="modal-body">
                    <p>
                      Enter OTP sent to your registered mobile number to confirm
                      redemption.
                    </p>
                    <input
                      type="text"
                      className="form-control text-center"
                      placeholder="Enter OTP"
                    />
                  </div>

                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={() => setShowOtp(false)}
                    >
                      Cancel
                    </button>
                    <button className="btn btn-primary">
                      Confirm Redemption
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
    </>
  );
}
